function ExperienceCard({ experience, index }) {
  const cardId =
    index === 0
      ? "current-role"
      : index === 1
      ? "past-experiences"
      : `experience-${index}`;
  return (
    <div
      id={cardId}
      className="p-6 border border-black/10 rounded-lg bg-white/50 hover:bg-white/80 hover:border-black/20 transition-all scroll-mt-20"
    >
      <div className="mb-4">
        <h3 className="font-display text-2xl font-bold text-hero-foreground">
          {experience.role}
        </h3>
        <p className="font-body text-lg font-semibold text-orange-600">
          {experience.company}
        </p>
        <p className="font-body text-sm text-muted-foreground">
          {experience.duration}
        </p>
      </div>

      <ul className="space-y-2">
        {experience.responsibilities.map((responsibility, index) => (
          <li key={index} className="flex gap-3 text-hero-foreground/80">
            <span className="inline-block w-1.5 h-1.5 bg-orange-600 rounded-full mt-2 flex-shrink-0" />
            <span className="font-body text-sm leading-relaxed">
              {responsibility}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ExperienceCard;
